import { Avatar, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useUser_GetUserByIdQuery } from 'queries';

import Spinner from 'common/spinner';
import { NotificationSeverity, showAlert } from 'utils/notification-manager';
import { nameToInitials } from 'utils/user';

type Props = {
  userId: string;
  showName?: boolean;
};

const useStyles = makeStyles((theme) => ({
  link: {
    cursor: 'pointer',
  },
  userImage: {
    fontSize: '1.05rem',
    width: theme.spacing(4),
    height: theme.spacing(4),
    marginRight: 10,
  },
  userAvatar: {
    fontSize: '1.05rem',
    width: theme.spacing(4),
    height: theme.spacing(4),
    whiteSpace: 'nowrap',
    minWidth: 'max-content',
  },
  userName: {
    whiteSpace: 'nowrap',
    minWidth: 'max-content',
  },
}));

export default function PortalUserDisplay({ userId, showName = true }: Props) {
  const classes = useStyles();

  const { data: userData, loading: userLoading } = useUser_GetUserByIdQuery({
    variables: { id: userId },
    onError: (e) => {
      showAlert({
        message: 'Error getting user by ID: ' + e.message,
        severity: NotificationSeverity.ERROR,
      });
    },
  });

  if (!userData && userLoading) {
    return <Spinner />;
  }

  const user = userData!.data;

  const hasAvatar = !!user.avatarPath;

  return (
    <div>
      <Grid container xs={12} alignItems="center">
        <Grid container xs={2}>
          {hasAvatar && (
            <img
              className={classes.userImage}
              loading="lazy"
              src={`${user.avatarUrl}`}
              srcSet={`${user.avatarUrl} 2x`}
              alt=""
            />
          )}
          {!hasAvatar && (
            <Avatar className={classes.userAvatar}>
              {nameToInitials(user.firstName, user.lastName)}
            </Avatar>
          )}
        </Grid>
        {showName && (
          <>
            <Grid container xs={2}>
              &nbsp;
            </Grid>
            <Grid container xs={2}>
              <span className={classes.userName}>{user.firstName + ' ' + user.lastName}</span>
            </Grid>
          </>
        )}
      </Grid>
    </div>
  );
}
